import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ModalProvider } from './contexts/ModalContext';
import Navbar from './components/Common/Navbar';
import Login from './pages/Login';
import Tenants from './pages/Tenants';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Profile from './pages/Profile';
import './App.css';

const AppRoutes: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const isLoginPage = location.pathname === '/' || location.pathname === '/login';

  if (loading) {
    return (
      <div className="app">
        <div className="app-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div>Chargement...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      {!isLoginPage && <Navbar />}
      <div className="app-content">
        <Routes>
          <Route 
            path="/" 
            element={isAuthenticated ? <Navigate to="/tenants" /> : <Login />} 
          />
          <Route 
            path="/login" 
            element={isAuthenticated ? <Navigate to="/tenants" /> : <Login />} 
          />
          <Route 
            path="/tenants" 
            element={isAuthenticated ? <Tenants /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/reports" 
            element={isAuthenticated ? <Reports /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/users" 
            element={isAuthenticated ? <Users /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/profile" 
            element={isAuthenticated ? <Profile /> : <Navigate to="/login" />} 
          />
        </Routes>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ModalProvider>
          <AppRoutes />
        </ModalProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
